@if (isContractCreated === true) {
  <div class="contract-summary">
    @if (blockedUi) {
      <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
        <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
      </div>
    }
    <div class="grid">
      <div class="col-12">
        <span class="title">Canal de Vendas</span>
      </div>
    </div>
    <div class="contract-created-card">
      <div class="contract-created-content">
        <h1>Parabéns!</h1>
        <h3>Você acaba de adquirir o seu Ford Protect. <br />
          A seguir você poderá acessar o texto do contrato com todas as informações do seu plano. <br />
        Obrigado e conte conosco!</h3>
      </div>
      <div class="col-12 contract-created-action">
        <button pButton class="btn-download contract-created-download"
          [disabled]="isDownloadingContract"
          [ngClass]="{ 'is-loading': isDownloadingContract }"
          [attr.aria-busy]="isDownloadingContract"
          (click)="downloadPDF()" type="button">
          @if (!isDownloadingContract) {
            <i class="pi pi-download" aria-hidden="true"></i>
          }
          @if (isDownloadingContract) {
            <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          }
          {{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' : 'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}
        </button>
        <!-- <button pButton class="ui-button" (click)="buttonHome()" type="button">
        Pagina Inicial
      </button> -->
    </div>
  </div>
</div>
}

@if (isContractCreated === false && !errorContract) {
  <div class="payment-signature-summary">
    @if (blockedUi) {
      <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
        <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
      </div>
    }
    <form [formGroup]="paymentSignatureForm">
      <div class="legal-main-card">
      <table id="pdfPaymentMethod" #pdfPaymentMethod style="width:100%; height:100% ">
        <tr>
          <td align="justify" width="100%">
            <div class="col-10 col-offset-1">
              <div class="p-fluid">
                @if (productCode === 'PREB') {
                  <div>
                    <app-payment-legal-text-contract-bra-preb></app-payment-legal-text-contract-bra-preb>
                  </div>
                }
                @if (productCode !== 'PREB') {
                  <div>
                    <app-payment-legal-text-contract-bra-bas1></app-payment-legal-text-contract-bra-bas1>
                  </div>
                }
                <div class="signature-consent-section">
                  <div class="consent-card">
                    <div class="consent-check" #termsConsent [class.terms-focus-active]="termsFocusActive">
                      <p-checkbox id="termsUser" binary="true" [(ngModel)]="termsUser"
                        formControlName="termsUser" required></p-checkbox>
                      <label for="termsUser" class="consent-label">
                        <b>{{ 'TRANSLATE.DECLARE.THAT.HAVE.READ.AGREE.CONDITIONS' | translate }}</b>
                      </label>
                    </div>
                    @if (submitted && f.termsUser?.errors) {
                      <p-message class="client-data-message" severity="error"
                        text="{{ 'TRANSLATE.REQUIRED.FIELD' | translate }}">
                      </p-message>
                    }
                  </div>
                  <div class="signature-meta-card">
                    <span class="signature-meta-label">{{ 'TRANSLATE.PLACE.DATE' | translate }}</span>
                    <span class="signature-meta-value">São Paulo, {{ getDay() }} de {{ getMonth() }} de {{ getYear() }}</span>
                  </div>
                  <div class="signature-panel">
                    <div class="signature-panel-header">
                      <span class="signature-panel-title">{{ 'TRANSLATE.TWO.POINTS.INSURED.SIGNATURE' | translate }}</span>
                    </div>
                    <div class="signature-box-container signature-canvas-shell" #signatureShell
                      [class.is-drawing]="isDrawing" [class.has-error]="submitted && f.signature?.errors">
                      <app-signature-pad #signaturePad formControlName="signature"
                        (changed)="drawComplete()" (drawing)="isDrawing = $event"></app-signature-pad>
                    </div>
                    @if (submitted && f.signature?.errors) {
                      <p-message class="client-data-message" severity="error"
                        text="{{ 'TRANSLATE.REQUIRED.FIELD' | translate }}">
                      </p-message>
                    }
                  </div>
                </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
          <table #pdfPaymentMethod style="width:100%; height:100% ">
            <tr>
              <td align="justify" width="100%">
                <div class="grid">
                  <div class="col-12 button-position">
                    <button pButton class="ui-button btn-back app-clean-button" (click)="drawClean()"
                      type="button" [disabled]="isSubmitted">
                      <i class="pi pi-trash" aria-hidden="true"></i>
                      {{ 'TRANSLATE.CLEAR.SIGNATURE' | translate }}
                    </button>
                    <button pButton [disabled]="isSubmitted"
                      [attr.aria-busy]="isSubmitted"
                      class="ui-button btn-next app-filter-button"
                      (click)="buttonNext()" type="button">
                      <i [ngClass]="isSubmitted ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-right'" aria-hidden="true"></i>
                      {{ (isSubmitted ? 'TRANSLATE.IN.PROCESSING' : 'TRANSLATE.ADVANCE') | translate }}
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </form>
      </div>
    }

    @if (errorContract) {
      <div>
        <span class="client-data-field-text">
          <span class="contract-error-message">
            {{ 'TRANSLATE.COULD.NOT.FIND.YOUR.CONTRACT' | translate }}
          </span>
        </span>
      </div>
    }